<template>
    <div class="container-fluid">
        <router-view class="view" />
    </div>
</template>

<script>
export default {
    setup() {
        
    },
}
</script>

<style scoped>

</style>